/**
 * Shared no-op handler for the StationDetails hidden-content rows
 * (favorites, paywall, report-issue) until their target intents land
 * (account auth, premium gating, issue-report flow). Lives in its own
 * module so AppShell.tsx stays a pure component file (the
 * `react-refresh/only-export-components` rule rejects mixed exports
 * from component files).
 *
 * Exercised directly by AppShell.test.tsx — clicking the wired rows
 * inside the AppShell integration suite is racy with the
 * full-panel-loader mount/unmount cycle under React 19 StrictMode.
 */
export const noopHiddenRowHandler = (): void => {
  /* no-op until the hidden-content row destinations are wired */
}
